import axios from "axios";
import HostService from "./host.service";
import AuthService from "./auth.service";
import {ID_CLIENTE_FINAL} from "../config/constants";

class AsignaService {

    static PROVEEDOR_ASIGNA = 'asigna';
    static PROVEEDOR_MSOFT = 'msoft';

    /**
     * Referencia con la que se registra el envío en la agencia: prefijo + SERIE-00123
     * @param {{serie: string, order: number|string}} sticker - Etiqueta del pedido
     * @returns {string} Referencia del envío
     */
    static referenciaEnvio(sticker) {
        return window.env.ASIGNA_PREFIX + sticker.serie + '-' + sticker.order.toString().padStart(5, "0");
    }

    /**
     * Obtener la nota (imagen o PDF del resguardo de entrega) de la agencia
     *
     * DECISION: cada proveedor espera una referencia distinta. Asigna la usa tal cual, así
     * que se le manda la misma con la que se registró el envío (referenciaEnvio). El backend
     * de MSoft la reconstruye él a partir de SERIE-NUM, así que se le manda el albarán.
     * @param {{serie: string, order: number|string}} sticker - Etiqueta del pedido
     * @param {{asigna: boolean, msoft: boolean}} agencia - Agencia de transporte del pedido
     * @returns {Promise<{data: string|null, format: string|null, message: string}>} Nota en base64, o mensaje si no hay
     */
    static getNote(sticker, agencia) {
        const proveedor = agencia.msoft ? this.PROVEEDOR_MSOFT : this.PROVEEDOR_ASIGNA;
        const referencia = agencia.msoft ? `${sticker.serie}-${sticker.order}` : this.referenciaEnvio(sticker);

        return axios.get(
            HostService.getHost() + 'envio/nota?referencia=' + encodeURIComponent(referencia) + '&proveedor=' + proveedor,
            AuthService.setToken()
        )
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.message);
                throw error;
            });
    }

    /**
     * Registrar envío en asigna
     * @param sticker
     * @returns {Promise<AxiosResponse<any>>}
     */
    static registerDelivery(sticker, delivery) {
        let comentario = sticker.comment;
        let proveedor;

        if (sticker.id_customer === ID_CLIENTE_FINAL && !comentario) {
            comentario = 'Particular. Si no esta en domicilio, llamar';
        }

        if (delivery.asigna) {
            proveedor = this.PROVEEDOR_ASIGNA;
        } else if (delivery.msoft) {
            proveedor = this.PROVEEDOR_MSOFT;
        }

        return axios.post(HostService.getHost() + 'envio?proveedor=' + proveedor,
            {
                "referencia": this.referenciaEnvio(sticker),
                "cp": sticker.cp,
                "direccion": sticker.address,
                "email": "",
                "nif": "",
                "nombre": sticker.name,
                "tel": sticker.phone,
                "bultos": sticker.packages,
                "comentario": comentario,
                "codcliente": '?',
                "departamento": sticker.departamento,
                "poblacion": sticker.county,
                "provincia": sticker.state
            }, AuthService.setToken())
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.message);
                throw error;
            });
    }
}

export default AsignaService;